@if (item.requires_accommodation) {
  <span
    class="inline-flex items-center justify-center text-emerald-600 dark:text-emerald-400"
    title="Requires overnight accommodation"
  >
    <lucide-icon [name]="CheckIcon" [size]="18" class="stroke-[2.5]"></lucide-icon>
    <span class="sr-only">Requires overnight accommodation</span>
  </span>
} @else {
  <span class="text-gray-300 dark:text-gray-600" title="No accommodation required">
    &mdash;<span class="sr-only">No accommodation required</span>
  </span>
}
